/* eslint-disable sonarjs/no-duplicate-string */

import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  pageNew: {
    id: "b2b.provozni-informace.page-heading.new",
    defaultMessage: "New operational information"
  },
  pageEdit: {
    id: "b2b.provozni-informace.page-heading.edit",
    defaultMessage: "Edit operational information"
  }
});

export default () => useMessages(MESSAGES);
